import { ValidatorForm } from '@/housefolios-components/shared/muiFormValidator'

// RFC 5321 caps a full address at 254 characters. Every auth page shares this
// rule and sentence so the limit reads the same on Sign In, Create Account and
// Recover Password.
export const EMAIL_MAX_LENGTH = 254
export const EMAIL_MAX_LENGTH_VALIDATOR = `maxStringLength: ${EMAIL_MAX_LENGTH}`
export const EMAIL_MAX_LENGTH_MESSAGE = `Email cannot exceed ${EMAIL_MAX_LENGTH} characters`

export const NAME_MAX_LENGTH = 50

// `matchRegexp` builds `new RegExp(param)` without flags, so `\p{L}` is not
// available there. Names go through a custom rule instead: any letter (with
// combining marks), spaces, hyphens, straight or curly apostrophes and periods,
// with at least one letter.
const PERSON_NAME_RE = /^(?=.*\p{L})[\p{L}\p{M} .'‘’-]+$/u

export const isPersonName = (value) => PERSON_NAME_RE.test(String(value))

ValidatorForm.addValidationRule('isPersonName', isPersonName)

export const VALIDATION_RULES = {
  email: {
    validators: ['required', EMAIL_MAX_LENGTH_VALIDATOR, 'isEmail'],
    errorMessages: [
      'This field is required',
      EMAIL_MAX_LENGTH_MESSAGE,
      'Not a valid email address',
    ],
  },
  password: {
    validators: [
      'required',
      'maxStringLength: 50',
      'minStringLength: 7',
    ],
    errorMessages: [
      'This field is required',
      'You cannot exceed 50 characters',
      'Password must be at least 7 characters long',
    ],
  },
  name: {
    validators: [
      'required',
      `maxStringLength: ${NAME_MAX_LENGTH}`,
      'isPersonName',
    ],
    errorMessages: [
      'This field is required',
      `You cannot exceed ${NAME_MAX_LENGTH} characters`,
      'Use only letters, spaces, hyphens, apostrophes and periods',
    ],
  },
  phone: {
    // Digits with an optional leading +, spaces, dots, parentheses and hyphens.
    validators: ['required', 'matchRegexp:^\\+?[0-9 ().-]+$'],
    errorMessages: [
      'This field is required',
      'Not a valid phone number',
    ],
  },
}
